export default {
  searching: 'Searching',
}
